export default __webpack_public_path__ + "static/media/welcome.7baab298.gif";